export default __webpack_public_path__ + "static/media/QuarterPipe_01.256.00e48f2a.png";